import Vue from "vue";

export const getLatestTermsOfUse = ({ commit }) => {
  return new Promise((resolve, reject) => {
    Vue.$axios
      .get("terms_of_use/latest")
      .then(call => {
        commit("SET_LATEST_TERMS_OF_USE", call.data);
        resolve(call.data);
      })
      .catch(() => reject());
  });
};

// export const getLatestTermsOfUseToAccept = ({ commit }) => {
//   return new Promise((resolve, reject) => {
//     Vue.$axios
//       .get("terms_of_use/latest_to_accept")
//       .then(call => {
//         commit("SET_LATEST_TERMS_OF_USE_TO_ACCEPT", call.data);
//         resolve(call.data);
//       })
//       .catch(() => reject());
//   });
// };

export const confirm = ({ commit }, version) => {
  return new Promise((resolve, reject) => {
    Vue.$axios
      .patch("terms_of_use/" + version + "/accept")
      .then(call => {
        commit("SET_LATEST_TERMS_OF_USE", call);
        resolve();
      })
      .catch(() => reject());
  });
};
